<template>
    <v-container>
      <v-card>
        <v-card-title>
          <v-btn
              v-if="perfil.co_perfil == codigosPerfil.CODIGO_ADMINISTRADOR"
              round
              color="success"
              class="text-none"
              @click="gerarRelatorioExcelListaIndicacaoConselho"
            >
              Gerar Relatório Excel
            </v-btn>
          <v-spacer />
          <v-text-field
            v-model="pesquisar"
            append-icon="search"
            label="Pesquisar"
            single-line
            hide-details
          />
        </v-card-title>
        <v-card-text class="pa-0">
          <v-data-table
            :headers="conselhoUtils.headersConselho"
            :items="conselhos"
            :pagination.sync="pagination_conselho"
            :total-items="totalItems"
            :loading="loading"
            :search="pesquisar"
            item-key="co_conselho"
            class="elevation-1"
          >
            <template
              slot="items"
              slot-scope="props"
            >
              <td>{{ props.item.cnpj_formatado }}</td>
              <td>{{ props.item.no_conselho }}</td>
              <td>{{ props.item.no_uf }}</td>
              <td>
                <v-chip
                  dark
                  color="primary"
                >
                  {{ props.item.no_regiao }}
                </v-chip>
              </td>
              <td class="text-xs-center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      depressed
                      outline
                      icon
                      fab
                      dark
                      color="primary"
                      small
                      style="padding-top: 5px"
                      v-on="on"
                      @click="editarConselhoIndicado(props.item);"
                    >
                      <v-icon medium>
                        list
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Visualizar</span>
                </v-tooltip>
              </td>
            </template>
          </v-data-table>
          
          <dialog-indicacao-conselho
            v-model="mostrarModalEdicao"
            :dados-conselho="conselhoEditado"
            @salvo="atualizar"
          />
        </v-card-text>
      </v-card>
    </v-container>
  </template>
  <script>
  import { mapActions, mapGetters } from 'vuex';
  import codigosPerfil from '../../conta/utils/codigosPerfil';
  import conselhoUtils from '../utils/conselhoUtils';
  
  import DialogIndicacaoConselho from './components/DialogIndicacaoConselho';
  
  export default {
    name: 'IndicacaoConselhoListaHabilitacao',
    components: {
      DialogIndicacaoConselho,
    },
    data: () => ({
      pesquisar: '',
      tipoModal: '',
      loading: true,
      codigosPerfil,
      conselhoUtils,
      pagination_conselho: {
        page: 1,
        rowsPerPage: 10,
        sortBy: 'no_conselho',
        descending: false,
      },
      totalItems: 0,
      conselhoEditado: {},
      mostrarModalEdicao: false,
      usuarioLogado: {},
  
    }),
    watch: {
      fases() {
        this.checkFaseHabilitacaoIndicacao();
      },
      usuario(valor) {
        this.usuarioLogado = valor;
      },
      usuarioLogado(usuario) {
        if (this.checkUsuario()) {
          this.obterIndicacaoConselhoPorAvaliador(usuario.co_usuario)
            .finally(() => this.loading = false);
        }
      },
    },
    computed: {
      ...mapGetters({
        perfil: 'conta/perfil',
        usuario: 'conta/usuario',
  
        fases: 'fase/fases',
        ativarHabilitacaoIndicacaoConselho: 'fase/ativarHabilitacaoIndicacaoConselho',
  
        conselhos: 'conselho/conselhos',
      }),
    },
    methods: {
      ...mapActions({
        definirMensagemErro: 'app/setMensagemErro',
        obterUsuarioLogado: 'conta/tratarUsuarioLogado',
        obterFases: 'fase/obterFases',
        obterIndicacaoConselhoPorAvaliador: 'conselho/obterIndicacaoConselhoPorAvaliador',
        gerarRelatorioExcelListaIndicacaoConselho: 'conselho/exportarExcelListaIndicacao'
      }),
      checkUsuario() {
        if (this.perfil.co_perfil != codigosPerfil.CODIGO_ADMINISTRADOR && this.perfil.co_perfil != codigosPerfil.CODIGO_AVALIADOR) {
          this.definirMensagemErro('Usuário não permitido!');
          this.$router.push('/');
          return false;
        }
        return true;
      },
      checkFaseHabilitacaoIndicacao() {
        if (this.perfil.co_perfil == codigosPerfil.CODIGO_AVALIADOR && !this.isFaseAtiva()) {
          this.definirMensagemErro('O prazo de Habilitação da Indicação está encerrado!');
          this.$router.push('/');
          return false;
        }
        return true;
      },
      isFaseAtiva() {
        return this.ativarHabilitacaoIndicacaoConselho;
      },
      editarConselhoIndicado(conselho) {
        this.conselhoEditado = conselho;
        this.mostrarModalEdicao = true;
      },
      atualizar(){
        this.loading = true;
        this.obterIndicacaoConselhoPorAvaliador(this.usuario.co_usuario)
        .finally(() => this.loading = false)
      },
      addListHeader(item) {
        const found = conselhoUtils.headersConselho.find(header => header.text === item);
        if (!found) {
            conselhoUtils.headersConselho.push({
                text: item,
                sortable: false,
                align: 'center',
            });
        }
      }
    },
    mounted() {
      this.addListHeader('Ações');

      if (this.fases && this.fases.length > 0) {
        this.checkFaseHabilitacaoIndicacao();
      }
      this.obterUsuarioLogado();
  
      this.usuarioLogado = this.usuario;
    },
  };
  </script>
  